import React, { Component } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import GlobalHelper from "../../common/GlobalHelper.jsx";
import Icon from "../../common/icon/icon.component.jsx";
import BillingMethodTotalLabel from "../../common/pricing/billingmethodtotallabel.component.jsx";
import LoadingSpinner from "../../common/spinner/loading.component.jsx";
import { Guard, Permissions } from "../../role/Guard.jsx";
import { BILLING_TYPE } from '../../state/invoice/InvoiceBillingType';
import DepositListModal from "./depositlistmodal.component.jsx";
import PricingTableModal from "./pricingtablemodal.component.jsx";

class AnalyticsQuoteAmounts extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            showFullTotal: this.props.showFullTotal || false,
            invoice: this.props.invoice || null,
            depositPayableObject: this.props.depositPayableObject || null,
            proposal: this.props.proposal || null,
            returns: this.props.returns || [],
            className: this.props.className || '',
            modal: '',
        }
        this.handleOpenPricingTableModal = this.handleOpenPricingTableModal.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.handleOpenDepositModal = this.handleOpenDepositModal.bind(this)
    }

    handleOpenDepositModal(e) {
        e.preventDefault()
        if (this.state.depositPayableObject) {
            this.setState({
                modal: <DepositListModal
                    contactId={this.state.depositPayableObject.attributes.contact.id}
                    quoteId={this.state.depositPayableObject.id}
                    onClose={this.handleCloseModal} />
            })
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            invoice: nextProps.invoice || null,
            proposal: nextProps.proposal || null,
            returns: nextProps.returns || [],
            depositPayableObject: nextProps.depositPayableObject || null,
        })
    }

    handleOpenPricingTableModal(e) {
        e.preventDefault()
        this.setState({
            modal: <PricingTableModal
                persistState={true}
                quote={this.state.depositPayableObject}
                invoice={this.state.invoice}
                onClose={this.handleCloseModal}
            />
        })
    }

    handleCloseModal() {
        this.setState({
            modal: ''
        })
    }

    invoiceReturnsTotal(returnsTotal, ret) {
        return returnsTotal + Math.abs(parseFloat(ret.attributes.totalAmount))
    }

    isReturn() {
        return this.state.invoice && this.state.invoice.attributes.billingType === BILLING_TYPE.RETURN
    }

    render() {
        const object = this.state.invoice || this.state.depositPayableObject || null
        if (!object) {
            return <LoadingSpinner />
        }
        const billingMethods = GlobalHelper.unique(object.attributes.items.map(r => r.attributes.billingMethod))
        return <div className={'row flex-grow-1'}>
            {this.state.modal}
            <div className={'col-12 d-flex flex-wrap'}>
                {billingMethods.length > 1 ?
                    <div className={'px-3 mr-2 bg-custom-primary'}>
                        <div className={'w-100'}>
                            <label className="col-form-label custom-form-label pt-2 text-white">
                                <strong>
                                    <FormattedMessage
                                        id="quote.analytics.total_value_label"
                                        defaultMessage="Total"
                                    />
                                </strong>
                            </label>
                        </div>
                        <h2 className={'m-0'}>
                            <FormattedNumber
                                value={this.state.showFullTotal ? object.attributes.totalAmount : object.attributes.totalValue}
                                style={'currency'}
                                currency={object.attributes.currency}
                            />
                        </h2>
                    </div> : ''}
                {object.attributes.totals.filter(t => billingMethods.includes(t.attributes.billingMethod)).map((t, key) => {
                    let total = this.state.showFullTotal ? t.attributes.totalAmount : t.attributes.totalAmountWithoutTax
                    let extra = (key !== 0 || billingMethods.length > 1) ? 'bg-secondary text-white' : 'bg-custom-primary'
                    extra = !this.isReturn() ? extra : 'bg-warning text-white'

                    return <div key={key} className={'px-3 mr-2 ' + extra}>
                        <div className={'w-100'}>
                            <label className="col-form-label custom-form-label pt-2 text-white">
                                <strong>
                                    <BillingMethodTotalLabel value={t.attributes.billingMethod} billingMethodsCount={billingMethods.length} />
                                </strong>
                            </label>
                        </div>
                        <h2 className={'m-0'}>
                            <FormattedNumber
                                value={total}
                                style={'currency'}
                                currency={t.attributes.currency}
                            />
                        </h2>
                        {t.attributes.marginRatio < 1 && Guard.isAuthorized(Permissions.ShowMargin) && !this.isReturn() ? <div className={'w-100'}>
                            <label className="col-form-label custom-form-label pt-2 text-white">
                                <strong>
                                    <FormattedMessage
                                        id="quote.analytics.margin_label"
                                        defaultMessage="Margin"
                                    />
                                </strong>
                            </label>
                        </div> : ''}
                        {t.attributes.marginRatio < 1 && Guard.isAuthorized(Permissions.ShowMargin) && !this.isReturn() ?
                            <h5 className={'m-0 border-0'}>
                                <FormattedNumber
                                    style="currency"
                                    currency={t.attributes.baseCurrency}
                                    value={t.attributes.margin}
                                />
                                &nbsp;
                                <small>
                                    (<FormattedNumber
                                        style="percent"
                                        value={t.attributes.marginRatio}
                                    />)
                                </small>
                            </h5> : ''}
                    </div>
                })}
                {
                    this.state.depositPayableObject &&
                        parseFloat(this.state.depositPayableObject.attributes.depositAmount) > 0 &&
                        parseFloat(this.state.depositPayableObject.attributes.depositBalance) > 0 &&
                        !GlobalHelper.hasShopifyIntegrationWithDisabledFeatures() ?
                        <div className={'px-3 mr-2 bg-dark'}>
                            <div className={'w-100'}>
                                <label className="col-form-label custom-form-label pt-2 text-white">
                                    <strong>
                                        <FormattedMessage
                                            id="quote.analytics.deposit_required_label"
                                            defaultMessage="Deposit required"
                                        />
                                    </strong>
                                </label>
                            </div>
                            <h2 className={'m-0 text-white'}>
                                <FormattedNumber
                                    value={this.state.depositPayableObject.attributes.depositBalance}
                                    style={'currency'}
                                    currency={this.state.depositPayableObject.attributes.currency}
                                />
                            </h2>
                        </div> : ''
                }
                {
                    this.state.depositPayableObject && parseFloat(this.state.depositPayableObject.attributes.depositPaidAmount) > 0 &&
                        !GlobalHelper.hasShopifyIntegrationWithDisabledFeatures() ?
                        <div className={'px-3 mr-2 bg-secondary'}>
                            <div className={'w-100'}>
                                <label className="col-form-label custom-form-label pt-2 text-white">
                                    <strong>
                                        <FormattedMessage
                                            id="quote.analytics.deposit_received_label"
                                            defaultMessage="Deposit received"
                                        />
                                    </strong>
                                </label>
                            </div>
                            <h2 className={'m-0 text-white'}>
                                <FormattedNumber
                                    value={this.state.depositPayableObject.attributes.depositPaidAmount}
                                    style={'currency'}
                                    currency={this.state.depositPayableObject.attributes.currency}
                                />
                            </h2>
                        </div> : ''
                }

                {
                    this.state.invoice &&
                        (this.state.invoice.attributes.billingType === BILLING_TYPE.ONETIME || this.isReturn()) &&
                        parseFloat(this.state.invoice.attributes.balance) !== 0 ?
                        <div className={'px-3 mr-2 bg-secondary'}>
                            <div className={'w-100'}>
                                <label className="col-form-label custom-form-label pt-2 text-white">
                                    <strong>
                                        {!this.isReturn() ?
                                            <FormattedMessage
                                                id="quote.analytics.balance_label"
                                                defaultMessage="Balance"
                                            />
                                            :
                                            <FormattedMessage
                                                id="quote.analytics.balance_to_refund_label"
                                                defaultMessage="Total left to refund"
                                            />
                                        }
                                    </strong>
                                </label>
                            </div>
                            <h2 className={'m-0 text-white'}>
                                <FormattedNumber
                                    value={this.state.invoice.attributes.balance}
                                    style={'currency'}
                                    currency={this.state.invoice.attributes.currency}
                                />
                            </h2>
                        </div> : ''
                }
                {
                    (object && parseFloat(object.attributes.pendingPaymentAmount)) ?
                        <div className={'px-3 mr-2 bg-primary'}>
                            <div className={'w-100'}>
                                <label className="col-form-label custom-form-label pt-2 text-white">
                                    <strong>
                                        <Icon className={'mr-1'} value={'hourglass-half'} />
                                        {
                                            parseFloat(object.attributes.pendingPaymentAmount) >= 0 ?
                                                <FormattedMessage
                                                    id="quote.analytics.pending_payment_label"
                                                    defaultMessage="Pending Payment"
                                                />
                                                :
                                                <FormattedMessage
                                                    id="quote.analytics.pending_refund_label"
                                                    defaultMessage="Pending Refund"
                                                />
                                        }
                                    </strong>
                                </label>
                            </div>
                            <h2 className={'m-0 text-white'}>
                                <FormattedNumber
                                    value={object.attributes.pendingPaymentAmount}
                                    style={'currency'}
                                    currency={object.attributes.currency}
                                />
                            </h2>
                        </div> : ''
                }

                {
                    this.state.returns.length > 0 ?
                        <div className={'px-3 mr-2 bg-warning'}>
                            <div className={'w-100'}>
                                <label className="col-form-label custom-form-label pt-2 text-white">
                                    <strong>
                                        <FormattedMessage
                                            id="quote.analytics.return_label"
                                            defaultMessage="Returns ({numberOfReturns})"
                                            values={{
                                                numberOfReturns: <strong>{this.state.returns.length}</strong>,
                                            }}
                                        />
                                    </strong>
                                </label>
                            </div>
                            <h2 className={'m-0 text-white'}>
                                <FormattedNumber
                                    value={-this.state.returns.reduce(this.invoiceReturnsTotal, 0)}
                                    style={'currency'}
                                    currency={this.state.invoice.attributes.currency}
                                />
                            </h2>
                        </div> : ''
                }

                <div className={'ml-2'}>
                    <div className={'mb-2'}>
                        <a target={'_blank'} href={'#'} className={'btn btn-sm btn-outline-primary w-100 text-left'} onClick={this.handleOpenPricingTableModal}>
                            <Icon value={'dollar-sign'} className={'mr-1'} />
                            <FormattedMessage
                                id="quote.analytics.pricing_table_btn"
                                defaultMessage="Show details"
                            />
                        </a>
                    </div>
                    {
                        this.state.depositPayableObject && !GlobalHelper.hasShopifyIntegrationWithDisabledFeatures() &&
                        <div >
                            <a target={'_blank'} href={'#'} className={'btn btn-sm btn-outline-primary w-100 text-left'} onClick={this.handleOpenDepositModal}>
                                <Icon value={'coins'} className={'mr-1'} />
                                <FormattedMessage
                                    id="quote.analytics.deposits_btn"
                                    defaultMessage="Show deposit details"
                                />
                            </a>
                        </div>
                    }
                </div>
            </div>
        </div>
    }

}

export default AnalyticsQuoteAmounts





// WEBPACK FOOTER //
// ./src/quote/analytics/quoteamounts.component.jsx